import { motion } from "framer-motion";
import { GYM } from "@/lib/gymData";

const GOALS = ["Weight Loss", "Weight Gain", "Muscle Building", "Strength Training", "Overall Fitness"];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative bg-obsidian py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-stretch">
          {/* Image block */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="relative min-h-[340px] lg:min-h-[520px] border border-white/10 overflow-hidden bg-black flex items-center justify-center"
          >
            <img src={GYM.logoFigure} alt="Fitness Point Gym" className="max-h-[78%] max-w-[80%] object-contain" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none" />
            <div className="absolute bottom-0 left-0 p-6 sm:p-8">
              <p className="font-display text-blaze text-5xl sm:text-6xl leading-none">100%</p>
              <p className="text-neutral-300 text-xs uppercase tracking-[0.2em] mt-1">Dedication Guaranteed</p>
            </div>
          </motion.div>

          {/* Text block */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="flex flex-col justify-center"
          >
            <p className="text-blaze text-xs uppercase tracking-[0.3em] mb-4">About Us</p>
            <h2 className="font-display text-white text-5xl sm:text-6xl xl:text-7xl leading-[0.9] tracking-tight">
              WHERE FITNESS MEETS DEDICATION
            </h2>
            <p className="mt-6 text-neutral-400 text-base leading-relaxed tracking-wide max-w-lg">
              Welcome to Fitness Point Gym. Whether your goal is weight loss, weight gain,
              muscle building, strength training or overall fitness — we are here to help
              you achieve it in a clean, motivating environment with modern equipment and
              personalized guidance.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              {GOALS.map((g) => (
                <span
                  key={g}
                  data-testid={`goal-${g.toLowerCase().replace(/\s/g, "-")}`}
                  className="border border-white/15 text-neutral-200 text-xs uppercase tracking-[0.15em] px-4 py-2 rounded-sm hover:border-blaze hover:text-blaze transition-colors"
                >
                  {g}
                </span>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
